import React from "react";
import CampaignContainer from "../containers/CampaignContainer";

export const CampaignPage: React.FunctionComponent = () => <CampaignContainer />; 